import { useLocation } from "react-router-dom";

const pageMessages: Record<string, string> = {
  "/": "Bonjour, j'ai vu votre site Carreaux-Bat et j'aimerais obtenir des informations sur vos services de carrelage et rénovation.",
  "/services": "Bonjour, j'ai visité votre page services et j'aimerais un devis pour un projet de carrelage ou de rénovation.",
  "/sion": "Bonjour, je suis sur votre page Sion et j'aimerais un devis pour un projet de carrelage à Sion.",
  "/sierre": "Bonjour, je suis sur votre page Sierre et j'aimerais un devis pour un projet de carrelage à Sierre.",
  "/martigny": "Bonjour, je suis sur votre page Martigny et j'aimerais un devis pour un projet de carrelage à Martigny.",
  "/grone": "Bonjour, je suis sur votre page Grône et j'aimerais un devis pour un projet de carrelage à Grône.",
  "/crans-montana": "Bonjour, je suis sur votre page Crans-Montana et j'aimerais un devis pour un projet de carrelage à Crans-Montana.",
  "/verbier": "Bonjour, je suis sur votre page Verbier et j'aimerais un devis pour un projet de carrelage à Verbier.",
  "/nendaz": "Bonjour, je suis sur votre page Nendaz et j'aimerais un devis pour un projet de carrelage à Nendaz.",
  "/vercorin": "Bonjour, je suis sur votre page Vercorin et j'aimerais un devis pour un projet de carrelage à Vercorin.",
  "/nax": "Bonjour, je suis sur votre page Nax et j'aimerais un devis pour un projet de carrelage à Nax.",
  "/contact": "Bonjour, j'ai visité votre page contact et j'aimerais des informations sur vos services de carrelage.",
};

export default function WhatsAppWidget() {
  const { pathname } = useLocation();
  const phoneNumber = "41775117552";

  const rawMessage = pageMessages[pathname] ?? pageMessages["/"];
  const message = encodeURIComponent(rawMessage);
  const whatsappUrl = `https://wa.me/${phoneNumber}?text=${message}`;

  return (
    <div className="fixed bottom-6 right-6 z-50 group">
      <div className="absolute bottom-16 right-0 mb-2 px-3 py-1.5 bg-stone-900 text-white text-xs font-medium rounded-md whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none">
        Disponible en général 7h-18h
        <span className="absolute bottom-[-4px] right-5 w-2 h-2 bg-stone-900 rotate-45"></span>
      </div>
      <a
        href={whatsappUrl}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Discuter sur WhatsApp"
        className="w-14 h-14 bg-green-500 rounded-full shadow-lg flex items-center justify-center hover:bg-green-600 transition-colors cursor-pointer whatsapp-pulse"
        style={{ boxShadow: "0 4px 14px rgba(0, 0, 0, 0.15)" }}
      >
        <i className="ri-whatsapp-line text-white text-2xl"></i>
      </a>
    </div>
  );
}